import { render, staticRenderFns } from "./VueDatatable.vue?vue&type=template&id=09bedd2a&scoped=true&"
import script from "./VueDatatable.vue?vue&type=script&lang=js&"
export * from "./VueDatatable.vue?vue&type=script&lang=js&"
import style0 from "./VueDatatable.vue?vue&type=style&index=0&id=09bedd2a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bedd2a",
  null
  
)

export default component.exports